const STORAGE_PREFIX = "sendProductBulk_attr_";
const TTL_MS = 60 * 60 * 1000;

export function buildAttributeCacheKey(userId, place, category) {
  if (!userId || !place?.id || !category?.id) return null;
  return `${STORAGE_PREFIX}${userId}_${place.type || "marketplace"}_${place.id}_${category.id}`;
}

export function buildCacheContext(place, category, placesCategory) {
  return {
    placeId: place?.id ?? null,
    placeType: place?.type ?? null,
    placeName: place?.name ?? null,
    categoryId: category?.id ?? null,
    categoryName: category?.name ?? category?.title ?? null,
    marketPlaceCategoryId: placesCategory?.marketPlaceCategoryId ?? null,
  };
}

export function matchesCacheContext(cachedContext, place, category, placesCategory) {
  if (!cachedContext || !place?.id || !category?.id) return false;
  const samePlace =
    cachedContext.placeId === place.id &&
    cachedContext.placeType === place.type;
  const sameCategory = cachedContext.categoryId === category.id;
  const mpCatId = placesCategory?.marketPlaceCategoryId;
  const sameMpCategory =
    mpCatId == null ||
    cachedContext.marketPlaceCategoryId == null ||
    cachedContext.marketPlaceCategoryId === mpCatId;
  return samePlace && sameCategory && sameMpCategory;
}

function cloneAttributeEntry({ attribute, value }) {
  return {
    attribute: attribute ? { ...attribute } : attribute,
    value:
      value != null && typeof value === "object"
        ? { ...value }
        : value,
  };
}

export function serializeSelectedAttributes(selectedAttributes) {
  if (!Array.isArray(selectedAttributes)) return [];
  return selectedAttributes.map(cloneAttributeEntry);
}

export function saveAttributeCache(cacheKey, context, selectedAttributes) {
  if (!cacheKey || !selectedAttributes?.length) return;
  try {
    const payload = {
      savedAt: Date.now(),
      context,
      selectedAttributes: serializeSelectedAttributes(selectedAttributes),
    };
    localStorage.setItem(cacheKey, JSON.stringify(payload));
  } catch (err) {
    console.warn("Özellik önbelleği kaydedilemedi:", err);
  }
}

export function loadAttributeCache(cacheKey) {
  if (!cacheKey) return null;
  try {
    const raw = localStorage.getItem(cacheKey);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data?.savedAt || Date.now() - data.savedAt > TTL_MS) {
      localStorage.removeItem(cacheKey);
      return null;
    }
    return data;
  } catch {
    localStorage.removeItem(cacheKey);
    return null;
  }
}

export function resolveFieldValueFromCache(item, cachedValue) {
  if (cachedValue == null || cachedValue === "") return cachedValue;
  if (typeof cachedValue !== "object") return cachedValue;
  if (!item?.attributeValues?.length) return cachedValue;
  const match = item.attributeValues.find(
    (opt) =>
      (cachedValue.id != null && String(opt.id) === String(cachedValue.id)) ||
      (cachedValue.name && opt.name === cachedValue.name)
  );
  return match || cachedValue;
}

export function buildFieldValuesFromAttributes(
  categoryItems,
  selectedAttributes
) {
  const map = {};
  if (!Array.isArray(selectedAttributes)) return map;
  selectedAttributes.forEach(({ attribute, value }) => {
    if (!attribute?.id) return;
    const item = categoryItems?.find(
      (i) => String(i?.attribute?.id) === String(attribute.id)
    );
    map[attribute.id] = item
      ? resolveFieldValueFromCache(item, value)
      : value;
  });
  return map;
}
